export default __webpack_public_path__ + "static/FoundersGrotesk-Regular-d15a2911e8a5b95096005156728f5145.woff";